import { codeSplit, Controller, FetchOptions, Result, AnalyticsStore } from 'bernie-core';
import { PageData } from 'bernie-http';
import { ProgramStore, UiStore } from 'stores';
import '../client/temp-common-imports';
import telemeter from '../observability/telemeter';
import { ProgramEvents } from '../observability/events/programs';

// util
import analyticsUtil from '../util/AnalyticsUtil';
import { pageNames } from '../data/page-names';

export class ProgramsController implements Controller {
  public pageId = pageNames.programs;
  public path = '/:localeName/programs';
  public routeName = 'programs';
  public bundles = [];

  public exact = true;

  public component = codeSplit(() => import(/* webpackChunkName: "programs-page" */ '../views/programs-page'));

  // tslint:disable-next-line:prefer-function-over-method
  public fetch(options: FetchOptions) {
    const { stores, query, request } = options;

    const analyticsStore: AnalyticsStore = stores && stores.get<AnalyticsStore>('analytics');
    const programs: ProgramStore = stores && stores.get<ProgramStore>('programs');

    const context = request.context;

    const uiStore = stores?.get<UiStore>('uiStore');
    uiStore?.setPageName(this.pageId);

    analyticsUtil.runAnalytics(pageNames.programs, analyticsStore, context);
    telemeter.increment(ProgramEvents.SUCCESS);

    // check for program live override
    if (query.showProgram) {
      programs.setForcedLive(query.showProgram);
    }

    return Promise.resolve(Result.ok());
  }

  // tslint:disable-next-line:prefer-function-over-method
  public fetchPageData(): Promise<PageData> {
    return Promise.resolve({ title: 'Affiliate Hub Programs' }) as Promise<PageData>;
  }
}
